// extracted by mini-css-extract-plugin
export default {"message-placeholder":"Articles_message-placeholder__B5PdW","button":"Articles_button__u+9UO"};